import { Carousel } from "./lib/carousel";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const carousel = new Carousel();
carousel.init();

Fancybox.bind("[data-fancybox]", {});

// Prevent events on nav items with '#' in the URL
const navItems = document.querySelectorAll('.c-nav-item__link');

navItems.forEach( $link => {
    if( $link.href.includes('#') ) {
        $link.addEventListener('click', (e) => {
            e.preventDefault();
        });
    }
});